import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../../../helpers"
import { Context, Transitions } from "../../../types"

export const getAssignedSubjectsByRefScopeTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "getAssignedSubjectsByRefScope",
    src: "getAssignedSubjectsByRefScope",
    onDone: {
      target:
        "#StudyPlan.teacher_view.get_teacher_relevant_plan_info_transition",
      actions: assign<Context, DoneInvokeEvent<any>>((ctx, evt) => {
        return {
          teacherAssignedSubjects: evt.data,
          ...((!ctx.subject || !evt.data.includes(ctx.subject)) && {
            subject: evt.data?.[0] ?? ctx.availableCourses?.[0]?.name
          })
        }
      }),
      cond: ctx => ctx.selfRefScope.scope === "TEACHER"
    },
    onError: {
      target: "#StudyPlan.teacher_view.idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        loading: false,
        teacherAssignedSubjects: [],
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("getAssignedSubjectsByRefScope", {
            messageData: ["get the selected study plan"]
          }),
          withUndo: false,
          error: true
        })
      }),
      cond: ctx => ctx.selfRefScope.scope === "TEACHER"
    }
  }
}
